import Vue from 'vue'
import Router from 'vue-router'
import Index from '../page/index.vue'
import Ranklist from '../page/ranklist.vue'
import Activity from '../page/activity.vue'
// import VUser from '../page/user.vue'
// import VDetail from '../page/detail.vue'
// import VDetailInfo from '../page/detailinfo.vue'
// import VTypelist from '../page/typelist.vue'
// import VCalendarday from '../page/calendarday.vue'
// import VMyconcerned from '../page/myconcerned.vue'
// import VRecommend from '../page/recommend.vue'
// import VExamlist from '../page/examlist.vue'
// import VExamdetail from '../page/examdetail.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // 前台路由
    // {
    //   path: '/',
    //   redirect: { name: 'home' }
    // },
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/ranklist',
      name: 'ranklist',
      component: Ranklist
    },
    {
      path: '/activity',
      name: 'activity',
      component: Activity
    },
    // {
    //   path: '/typelist/:fid',
    //   name: 'typelist',
    //   component: VTypelist
    // },
    // {
    //   path: '/user',
    //   name: 'user',
    //   component: VUser
    // },
    // {
    //   path: '/myconcerned',
    //   name: 'myconcerned',
    //   component: VMyconcerned
    // },
    // {
    //   path: '/detail/:id',
    //   name: 'detail',
    //   component: VDetail
    // },
    // {
    //   path: '/detailinfo/:id',
    //   name: 'detailinfo',
    //   component: VDetailInfo
    // },
    // {
    //   path: '/recommend',
    //   name: 'recommend',
    //   component: VRecommend
    // },
    // {
    //   path: '/examlist',
    //   name: 'examlist',
    //   component: VExamlist
    // },
    // {
    //   path: '/examdetail/:id',
    //   name: 'examdetail',
    //   component: VExamdetail
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js